.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
